var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-app',{attrs:{"params":_vm.f7params}},[_c('f7-view',{attrs:{"id":"view-other_home","name":"other_home","tab":"","url":"/"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }